<template>
  <el-menu :default-active="$route.path" :collapse="isCollapse" class="el-menu-vertical" router
    background-color="#001529" text-color="#fff" active-text-color="#409EFF">
    <!-- 顶部 LOGO 和 系统名称 -->
    <div class="logo-section">
      <img src="@/assets/sud.png" class="logo" />
      <span v-if="!isCollapse" class="system-name">智能数据系统</span>
    </div>

    <!-- 菜单项 -->
    <el-menu-item index="/kaiyuan-data">
      <el-icon>
        <Document />
      </el-icon>
      <span>开缘数据列表</span>
    </el-menu-item>

    <el-menu-item index="/data-list">
      <el-icon>
        <Filter />
      </el-icon>
      <span>精选数据列表</span>
    </el-menu-item>

    <!-- <el-menu-item index="/scraped-data">
      <el-icon><Folder /></el-icon>
      <span>采集数据列表</span>
    </el-menu-item> -->
    <el-menu-item index="/vector">
      <el-icon>
        <Odometer />
      </el-icon>
      <span>领域知识库</span>
    </el-menu-item>

    <el-menu-item index="/vector-agent">
      <el-icon>
        <ChatLineRound />
      </el-icon>
      <span>左脑智能问答</span>
    </el-menu-item>

    <el-menu-item index="/mcp-agent">
      <el-icon>
        <ChatLineRound />
      </el-icon>
      <span>右脑智能问答</span>
    </el-menu-item>

    <el-menu-item index="/chat">
      <el-icon>
        <Service />
      </el-icon>
      <span>智能聊天辅助</span>
    </el-menu-item>
    <el-menu-item index="/ollama-model">
      <el-icon>
        <Odometer />
      </el-icon>
      <span>大模型管理</span>
    </el-menu-item>
    <el-menu-item index="logout" @click="handleLogout">
      <el-icon>
        <SwitchButton />
      </el-icon>
      <span>退出</span>
    </el-menu-item>
    <!-- 折叠按钮 -->
    <div class="collapse-btn" @click="toggleCollapse">
      <el-icon>
        <ArrowLeft v-if="!isCollapse" />
        <ArrowRight v-else />
      </el-icon>
    </div>
  </el-menu>
</template>

<script setup>
import { ref } from 'vue'
import { Document, Folder, SwitchButton, Odometer, Service, ArrowLeft, ArrowRight, ChatLineRound, Filter, QuestionFilled } from '@element-plus/icons-vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'

const isCollapse = ref(false)
const router = useRouter();

const toggleCollapse = () => {
  isCollapse.value = !isCollapse.value
}

const handleLogout = () => {
  ElMessageBox.confirm("是否确认退出系统？", "退出提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  }).then(() => {
    localStorage.removeItem("token"); // 清除本地存储的用户信息
    ElMessage.success("退出成功");
    router.push("/login"); // 跳转到登录页面
  }).catch(() => {
    ElMessage.info("已取消退出");
    router.back();
  });
};
</script>

<style scoped>
.el-menu-vertical {
  width: auto;
  height: 100vh;
  border-right: none;
}

.logo-section {
  display: flex;
  align-items: center;
  padding: 12px;
  background: #002140;
  color: #fff;
}

.logo {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}

.system-name {
  font-size: 16px;
  font-weight: bold;
}

.collapse-btn {
  margin-top: auto;
  padding: 12px;
  text-align: center;
  color: #aaa;
  cursor: pointer;
}
</style>
